import { render, staticRenderFns } from "./CreateGlLevel1Form.vue?vue&type=template&id=84efb108&scoped=true&"
import script from "./CreateGlLevel1Form.vue?vue&type=script&lang=js&"
export * from "./CreateGlLevel1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84efb108",
  null
  
)

export default component.exports